export default __webpack_public_path__ + "media/images/icons/favicon-48x48-948e6013c6a866f69cfd10641f0c724b.png";